import _ from 'lodash'
import { diff } from '../lib/render-object'

const mapper = (text) => {
  return {
    'approles': 'Application Roles',
    'defaultportfolios': 'Default Portfolios',
  }[text] || _.startCase(text)
}

const filterKeys = (obj) => obj && _.pick(obj, ['email', 'name', 'approles', 'enabled'])

const alwaysKeep = ['name', 'email']

export const diffif = (props) => {
  if (props.resource !== 'user') return null

  return () => {
    let {originaluser, user} = JSON.parse(props.change)
    user = filterKeys(user)
    originaluser = filterKeys(originaluser)
    const diffs = diff(originaluser, user, mapper, alwaysKeep)

    const atRest =
      props.method == 'POST' ? 'Created User' : 
      props.method == 'DELETE' ? 'Deleted User' : 'User Change'

    return {diffs, atRest, ...props, _showCreate: true}
  }
}